export const BEAMING_LIST = "beaming_list";
export const BEAMING_LIST_SUCCESSFULL = "beaming_list_successfull";
export const BEAMING_DD_LIST = "beaming_dd_list";
export const BEAMING_DD_LIST_SUCCESSFULL = "beaming_dd_list_successfull";
export const BEAMING_CREATE = "beaming_create";
export const BEAMING_CREATE_SUCCESSFULL = "beaming_create_successfull";
export const BEAMING_DELETE_ROW = "beaming_delete_row";
export const BEAMING_DELETE_ROW_SUCCESSFULL = "beaming_delete_row_successfull";